// 공통 비밀번호 유효성 규칙 — 백엔드(Spring Security) 정책과 동기화
// 변경 시 이 파일 하나만 수정하면 모든 폼에 반영됩니다.

export const PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{10,}$/;

export const PASSWORD_RULE_MESSAGE =
  '비밀번호는 최소 10자 이상, 대문자·소문자·숫자·특수문자(@$!%*#?&)를 모두 포함해야 합니다.';

/** 입력 필드 아래 실시간 조건 체크 목록 */
export const getPasswordChecks = (password: string) => [
  { label: '10자 이상',                          ok: password.length >= 10 },
  { label: '대문자 포함',                         ok: /[A-Z]/.test(password) },
  { label: '소문자 포함',                         ok: /[a-z]/.test(password) },
  { label: '숫자 포함',                           ok: /\d/.test(password) },
  { label: '특수문자 포함 (@$!%*#?&)',            ok: /[@$!%*#?&]/.test(password) },
  { label: '허용된 문자만 사용 (영문·숫자·@$!%*#?&)', ok: password.length === 0 || /^[A-Za-z\d@$!%*#?&]+$/.test(password) },
];
